import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EntreprisesRoutingModule } from './entreprises-routing.module';
import { ListeEntreprisesComponent } from './liste-entreprises/liste-entreprises.component';
import { DetailsEntreprisesComponent } from './details-entreprises/details-entreprises.component';
import { NgSelectModule } from '@ng-select/ng-select';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { PaginationModule } from './../../shared/components/pagination/pagination.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RatingModule } from 'ngx-bootstrap/rating';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxIntlTelephoneInputModule } from 'ngx-intl-telephone-input';
import { OffreEntreprisesComponent } from './offre-entreprises/offre-entreprises/offre-entreprises.component';
import { ListeEntrepriseClientfinalComponent } from './liste-entreprises-clientfinal/liste-entreprise-clientfinal/liste-entreprise-clientfinal.component';
import { ContacterResponsableComponent } from './contacter-responsable/contacter-responsable/contacter-responsable.component';
import { SharedModule } from "app/shared/shared.module";
import { MatMenuModule } from '@angular/material/menu';
@NgModule({
  declarations: [
    ListeEntreprisesComponent,
    DetailsEntreprisesComponent,
    OffreEntreprisesComponent,
    ListeEntrepriseClientfinalComponent,
    ContacterResponsableComponent,
  ],
  imports: [
    CommonModule,
    EntreprisesRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    PaginationModule,
    NgxSpinnerModule,
    RatingModule.forRoot(),
    NgxIntlTelInputModule,
    NgxIntlTelephoneInputModule,
    SharedModule,
    MatMenuModule
  ],
})
export class EntreprisesModule {}
